export default "__VITE_ASSET__DbX1qsar__"